import React from 'react';
import { useTheme } from '@mui/material';
import DSBox from '../../../design-system/DSBox';
import DSTypography from '../../../design-system/Typography/DSTypography';
import FAQAccordion from './FAQAccordion';
import useStudioFaq from '../../../hooks/useStudioFaq';

const HelpFAQ = () => {
  const { spacing } = useTheme();
  const { data, isPending, isError } = useStudioFaq();

  if (isPending) {
    return (
      <DSTypography variant="body2" sx={{ color: 'text.secondary' }}>
        Loading FAQ...
      </DSTypography>
    );
  }

  if (isError || !data?.items?.length) {
    return (
      <DSTypography variant="body2" sx={{ color: 'text.secondary' }}>
        FAQ is currently unavailable.
      </DSTypography>
    );
  }

  const items = data.items;
  const mid = Math.ceil(items.length / 2);
  const leftColumnFAQs = items.slice(0, mid);
  const rightColumnFAQs = items.slice(mid);

  return (
    <DSBox
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: '1fr 1fr',
        },
        gap: spacing(4),
      }}
    >
      <DSBox>
        <FAQAccordion faqs={leftColumnFAQs} />
      </DSBox>
      <DSBox>
        <FAQAccordion faqs={rightColumnFAQs} />
      </DSBox>
    </DSBox>
  );
};

export default HelpFAQ;
